/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ contact: NonNullable<unknown> }} Terms_Complaints_1Inputs */

const da_terms_complaints_1 = /** @type {(inputs: Terms_Complaints_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kontakt os først på ${i?.contact}. Forbrugere kan klage til Nævnenes Hus, Toldboden 2, 8800 Viborg ([naevneneshus.dk](https://naevneneshus.dk)). Aftalen er underlagt dansk ret.`)
};

/** @type {(inputs: Terms_Complaints_1Inputs) => LocalizedString} */
const en_terms_complaints_1 = da_terms_complaints_1;

/**

* @param {Terms_Complaints_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_complaints_1 = /** @type {((inputs: Terms_Complaints_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Complaints_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_complaints_1(inputs)
	return da_terms_complaints_1(inputs)
});